import React from 'react';
import { Field, RadioGroup } from '../../../../Core';
import { ListFieldSection, FieldSet } from '../../../../Layout';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { useSelector } from 'react-redux';
import PreparationWetSection from '../../Shared/PreparationWetSection';
import PreparationDrySection from '../../Shared/PreparationDrySection';
import PreparationAsReceivedWaterContentSection from './PreparationAsReceivedWaterContentSection';
import { pipe } from 'Lib/Hooks/Selectors';
import { valueOrDefault } from 'Lib/Any';
import { IWithWorksheetInjectedProps } from 'Components/Worksheets/Core';
import { AdditionalVisualDescription } from 'Components/Worksheets/Core/Fields';

let PreparationSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const testForOrganics = useSelector(
    pipe(createWorksheetSelector!('Preparation.TestForOrganics'), valueOrDefault(false))
  );
  const preparationMethod = useSelector(createWorksheetSelector!('Preparation.PreparationMethod'));

  return (
    <>
      <ListFieldSection name="Preparation">
        <FieldSet>
          <Field
            input={<RadioGroup />}
            label="Preparation Method"
            name="Preparation.PreparationMethod"
            options={['Wet', 'Dry'].map((e) => ({ label: e, value: e }))}
          />
        </FieldSet>
        <AdditionalVisualDescription editable appendNamePrefix="Preparation" />
        <FieldSet>
          <Field
            input={<RadioGroup />}
            label="Test for Organics"
            name="Preparation.TestForOrganics"
            confirm={testForOrganics}
            confirmTitle="Confirm Test For Organics Change"
            confirmText="Any existing data for the oven dried liquid limit will be removed."
            confirmButtonText="Change Test For Organics"
            options={[
              { value: true, label: 'Yes' },
              { value: false, label: 'No' },
            ]}
          />
        </FieldSet>
      </ListFieldSection>
      {preparationMethod === 'Wet' ? <PreparationWetSection /> : <PreparationDrySection />}
      <PreparationAsReceivedWaterContentSection />
    </>
  );
};

PreparationSection = withInjectedProps(PreparationSection);

export { PreparationSection };
export default PreparationSection;
